import Styled from 'styled-components'

export const Container = Styled.div`
.swiper-pagination-bullet{
    display: none !important;
  }
    
`

export const CotainerProduct = Styled.div`
text-align: center;
justify-content: center;
display: flex;


.card-img-top{
    cursor: pointer;
    height: 100%;
    width: 100%;
}

.btn:focus{
    box-shadow: none !important;
}

.items{
  @media(max-width: 800px) {
  width: 11.2rem !important;  

}
}

.title{
    text-align: center;
    font-weight: bold;
    padding: 1rem;
    max-width: 30ch;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.spots{
    font-weight: bold;
    margin-top: 25px;
}

span{
    font-size: 12px;
    font-weight: 500;
}

.card-body{
    padding: 0 !important;
}

.button{
   margin-top:20px;
   width: 100%;
   border: none;
   padding-top: 10px;
   padding-bottom: 10px;
   font-size: 13px;

   @media(max-width: 800px) {
  font-size: 10px; 
}
}

.star{
    position: absolute;
    width:30px;
    height:30px; 
    top: 6px;
    margin-left:235px;
    position:fixed;

    @media(max-width: 800px) {
    margin-left: 134px;
}

}
`

export const Cashback = Styled.div`
width: 100%;

p{
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 12px;

}
`
export const TitleProduct = Styled.p`
 font-size: 20px;
 word-wrap: break-word;
 color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
`

export const Section = Styled.section`
 display:block;
 margin-top: 6px;
 margin-bottom: 20px;
`

/* Desktop (>=1024px): grid multi-coluna no lugar do carrossel de produtos */
export const DesktopProductsGrid = Styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;

  @media (min-width: 1024px) and (max-width: 1280px) {
    grid-template-columns: repeat(4, 1fr);
  }

  .grid-cell {
    position: relative;
  }
`

export const ContainerTitle = Styled.div`
 justify-content: space-between;
 display: flex;
 align-items: center;
 text-align: center;
 margin-top: 50px;
 padding:0.125rem;
`